<template>
    <main id="container-wrap-footer">

        <!-- Header -->
        <section id="content-footer">
            <div id="promo2">
                <div class="container">
                    <div>
                        <img src="@/assets/coupon/img/img-todoenglish-logo-wh-large.svg" class="img_todoenglish_logo">
                    </div>
                    <div id="store-btn-bg">
                        <div class="white-btn btn" v-on:click='handleDownloadClick'>
                            <p>App download</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class='footer'>
                <div class="container">
                    <p class="rights">ⓒ 2018 Enuma, Inc. All Rights Reserved.</p>
                    <div>
                        <p>北京埃努码信息技术有限公司</p>
                        <p class="v-line"></p>
                        <p style="color: #cccccc;">法人 &nbsp;</p>
                        <p>李在轩</p>
                        <p class="v-line"></p>
                        <p>京ICP备16005665号-1</p>
                    </div>
                    <p>北京市朝阳区工人体育场北里8号院1号楼10层01-1105第A1157号办公室</p>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
export default {
    methods: {
        handleDownloadClick() {
            window.open('/cn/download', '_blank')
        }
    }
}
</script>
<style src="@/assets/coupon/style.css" scoped></style>
<style src="@/assets/coupon/footer.css" scoped></style>


// WEBPACK FOOTER //
// src/pages/coupon/Footer.vue